export enum Tabs{
    Overzicht='Overzicht',
    Rating='Rating',
    More='Meer'
}
